/**
 * The Finding Severity of one scored question, as the Risk Finding pill shows it: the SME tier
 * when one is set, otherwise the engine's finding type, otherwise its severity band. The Excel
 * and PDF exports apply the same rule (RiskFindingVerdict in the export worker); keep the two in
 * step or the exports stop matching the screen.
 */
const COMPLIANT = "Compliant";
const NOT_SCORED = "Not Scored";

const LABELS = {
  compliant: COMPLIANT,
  "not scored": NOT_SCORED,
  notscored: NOT_SCORED,
  low: "Low",
  medium: "Medium",
  high: "High",
  critical: "Critical",
};

const NOT_SCORED_FINDING_TYPES = new Set(["", "notscored", "undetermined", "outofscope"]);

const BUCKETS = { Critical: "critical", High: "high", Medium: "medium", Low: "low" };

const normalizeLabel = (value) => {
  const trimmed = String(value).trim();
  return LABELS[trimmed.toLowerCase()] ?? trimmed;
};

export const findingSeverityOf = (row) => {
  const smeTier = String(row?.sme_tier ?? "").trim();
  if (smeTier) return normalizeLabel(smeTier);

  const findingType = String(row?.finding_type ?? "").trim().toLowerCase();
  if (findingType === "compliant" || findingType === "notapplicable") return COMPLIANT;
  if (NOT_SCORED_FINDING_TYPES.has(findingType)) return NOT_SCORED;

  const band = String(row?.auto_final_risk ?? "").trim();
  return band ? normalizeLabel(band) : "Low";
};

export const isFindingSeverity = (label) => Object.hasOwn(BUCKETS, label);

/** One bucket per row: critical, high, medium, low, compliant or notScored. */
export const countFindingSeverities = (rows) => {
  const counts = { critical: 0, high: 0, medium: 0, low: 0, compliant: 0, notScored: 0 };
  for (const row of Array.isArray(rows) ? rows : []) {
    const label = findingSeverityOf(row);
    if (label === COMPLIANT) counts.compliant += 1;
    else if (label === NOT_SCORED) counts.notScored += 1;
    else counts[BUCKETS[label] ?? "low"] += 1;
  }
  return counts;
};
